// Б.2.c: Торчок (single trigger по xlsx v6).
//
// Триггер «конец каждого хода» (диздок v2.9, xlsx dsl_trigger1):
//   damage:1@ally_random | damage:1@enemy_random
//
// 1 урон случайному союзному ЮНИТУ И 1 урон случайному вражескому ЮНИТУ
// (две независимые случайные выборки). Герои в пул не входят.
//
// Торчок ВКЛЮЧЁН в союзный пул — может попасть сам в себя (фишка карты:
// он торчок, ему наплевать). Если союзный пул пуст (нет юнитов
// кроме умершего Торчка) — союзная часть пропускается. То же для вражеского.
//
// Триггер начинает работать СО СЛЕДУЮЩЕГО хода после выставления
// (revealed=true после Ф3). Через u.revealed: до Ф3 хода появления —
// не триггерим.
//
// ИСТОРИЯ: до миграции на v6 у Торчка был второй триггер «призвать
// копию после Ф5». В новой таблице xlsx этого нет — копии убраны.
// Этот файл больше НЕ экспортирует torchokOnTurnStart / torchokEot.

import { applyDamage } from '../../combat.js';
import { dispatchUnitDied } from '../deus/hooks.js';
import { notifyCharacterDamaged } from './temnyy-netranner.js';

export const CARD_ID = 'syn_torchok';

// === Триггер: end-of-turn ===
export function torchokOnTurnEnd(state, idx, torchok) {
  if (!torchok.isAlive()) return;
  if (!torchok.revealed) return; // ещё не был в Ф3 этого хода

  const me  = state.players[idx];
  const enemy = state.players[1 - idx];

  // Союзный пул: ВСЕ юниты владельца (включая самого Торчка — он тоже юнит).
  // Герой НЕ входит — по тексту триггера и по dsl `@ally_random`.
  const allyPool = me.unitsOnField();
  const enemyPool = enemy.unitsOnField();

  if (allyPool.length === 0 && enemyPool.length === 0) return;

  const allyTarget  = allyPool.length  > 0 ? allyPool[state.rng.int(allyPool.length)]   : null;
  const enemyTarget = enemyPool.length > 0 ? enemyPool[state.rng.int(enemyPool.length)] : null;

  const allyLbl  = allyTarget  ? allyTarget.name_ru  : '—';
  const enemyLbl = enemyTarget ? enemyTarget.name_ru : '—';
  state.log.add(`💉 Торчок [${me.name}]: 1 урон по ${allyLbl} (свой) и по ${enemyLbl} (враг)`);

  if (allyTarget)  dealOneDamage(state, idx,       allyTarget,  me);
  if (enemyTarget) dealOneDamage(state, 1 - idx,   enemyTarget, enemy);
}

// 1 урон юниту через applyDamage + лог + проверка смерти.
function dealOneDamage(state, ownerIdx, target, ownerPlayer) {
  const before = { hp: target.hp, armor: target.armor };
  const r = applyDamage(target, 1, { pierce: false });
  const taken = (r.armorAbsorbed || 0) + (r.hpLost || 0);
  state.log.add(`  → ${target.name_ru} [${ownerPlayer.name}]: HP ${before.hp}→${target.hp}, броня ${before.armor}→${target.armor}`);
  if (taken > 0) notifyCharacterDamaged(state, ownerIdx, target, taken);
  if (target.hp <= 0) {
    ownerPlayer.removeFromField(target);
    state.log.add(`✗ ${target.name_ru} [${ownerPlayer.name}] погибает`);
    dispatchUnitDied(state, {
      ownerIdx, card: target,
      killer: null, killerIdx: null, killerWasCounter: false
    });
  }
}
